import React, { useEffect, useState } from "react";
import StudentInfoComponent from "./StudentInfo.component";
import { getStudentInfo } from "api/student/v2/student.api";
import { useParams } from "react-router-dom";
import { addFollow, cancelFollow } from "api/student/Follow.api";
const StudentInfoContainer = () => {
    const { studentId } = useParams();
    const [isInit, setIsInit] = useState(false);
    const [info, setInfo] = useState<any>(null);
    const [errorMessage, setErrorMessage] = useState("");

    const [isOnNetworking, setIsOnNetworking] = useState(false);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            const data = await getStudentInfo(studentId);
            if (data?.info) {
                setInfo(data.info);
            }
        } catch (error: any) {
            console.error(error);
            setErrorMessage(error.message || "Unknown error occurred while loading student info");
        } finally {
            setIsInit(true);
        }
    };



    const onFollow = async (studentId: number) => {
        console.log("onFollow", studentId);
        if (isOnNetworking) return;
        setIsOnNetworking(true);
        try {
            const data = await addFollow(studentId);
            if (data) {
                setInfo((prev: any) => prev ? { ...prev, isFollowing: true } : null);
            }
        } catch (error: any) {
            console.error(error);
        } finally {
            setIsOnNetworking(false);
        }
    };

    const onUnfollow = async (studentId: number) => {
        console.log("onUnfollow", studentId);
        if (isOnNetworking) return;
        setIsOnNetworking(true);
        try {
            const data = await cancelFollow(studentId);
            if (data) {
                setInfo((prev: any) => prev ? { ...prev, isFollowing: false } : null);
            }
        } catch (error: any) {
            console.error(error);
        } finally {
            setIsOnNetworking(false);
        }
    };

    return <StudentInfoComponent
        isInit={isInit}
        info={info}
        errorMessage={errorMessage}
        studentId={studentId}
        handleFollow={onFollow}
        handleUnfollow={onUnfollow}
        isOnNetworking={isOnNetworking}
    />;
};

export default StudentInfoContainer;